import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ReleaseConfigurationMappingDto } from '@app/shared/model/addOrUpdateReleaseConfigDto';
import { LoaderService } from '@app/shared/services/loader.service';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ripple, textField, formField } from 'material-components-web';
import { ToastrService } from 'ngx-toastr';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { DropdownModule } from 'primeng/dropdown';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { InputTextModule } from 'primeng/inputtext';
import { DeploymentStatusDto } from '@app/apiModules/DeploymentStatusDto';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeploymentCommentComponent } from '../deployment-status/deployment-comment/deployment-comment.component';
import { ConfirmationDialogService } from '@app/shared/services/confirmation-dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-create-or-update-release',
  templateUrl: './create-or-update-release.component.html',
  styleUrls: ['./create-or-update-release.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, DropdownModule, MatCheckboxModule, CommonModule, MatTooltipModule, TableModule, MultiSelectModule, PageHeaderComponent, InputTextModule, RouterModule,MatTooltipModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatSelectModule, NgxMatSelectSearchModule]
})
export class CreateOrUpdateReleaseComponent implements OnInit , OnDestroy{
  form: FormGroup;
  releaseServicesList: any[] = [];
  versionTypeList: any[] = [];
  environmentsList: any[] = [];
  releaseId: number = 0;
  configSerInfoMsg = "Select Applicable Services";
  configEnvInfoMsg = "Select Applicable Environments";
  configReleaseNameInfoMsg = "Allowed: Alphabets, Numbers, Full Stop and Hyphen. Maximum length: 50 characters.";
  configVersionTypeInfoMsg = "Select Version Type";
  configVersionNumberInfoMsg = "Only Numbers and Full Stop is allowed";
  allselected: boolean = false;
  selectedVersionType: string = 'Major';
  editableVersion: string;
  readonlyMode: boolean = false;
  allSelected: boolean = false;
  isIndeterminate: boolean = false;
  defaultVersionTypeList: { label: string; value: string }[] = [
    { label: 'Major', value: 'Major' },
    { label: 'Minor', value: 'Minor' },
  ];
  envServiceMap: { [env: string]: string } = {};
  AllServiceList: any[];
  InfoForService: any;
  public tooltipMessage = 'Select All / Unselect All';
  allElementsSelected=false;
  anyElementsSelected=false;
  /** control for the MatSelect filter keyword multi-selection */
  public environmentsFilterCtrl: FormControl<string> = new FormControl<string>('');
  /** list of environments filtered by search keyword */
  public filteredEnvironmentsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  /** Subject that emits when the component has been destroyed. */
  _onDestroy = new Subject<void>();
  enableAuditTrail: boolean = false;
  configEnvironmentsInfoMsg = "Show environments associated with a service";
  AllMappingList: any;
  hideField: boolean = false;
  constructor(public loader: LoaderService, public releaseMgmtService: ReleaseMgmtService,
    public readonly router: Router, public route: ActivatedRoute, public toastr: ToastrService,
    private cdr: ChangeDetectorRef, public userAuthService: UserAuthService, public dialog: MatDialog,
    private confirmationDialog: ConfirmationDialogService
  ) { }


  ngOnInit() {
    this.form = new FormGroup({
      releaseName: new FormControl(null, [Validators.required]),
      releasePrefix: new FormControl(null, [Validators.required]),
      environments: new FormControl(null, [Validators.required]),
      selectedVersionType: new FormControl('Major', [Validators.required]),
    });
    this.filteredEnvironmentsMulti.next([]);
    //API call to get all ENV and  services
    
    this.loader.showSpinner.next(true);
    this.releaseMgmtService.apiGetAllServicesAndEnvironmentDetails().subscribe({
      next: (res) => {
        if (res) {
          //Service List from Master Legos-All services
          this.AllServiceList = res.servicesConfig.map((service: any) => {
            const serviceDto = {
              // code: service.code,
              isSelected: service.isSelected || false,
              serviceName: service.name,
              versionType: '',
              isAlreadyExist: service.IsAlreadyExist,
              versionNumber: '',
              previousNumber: '',
              lastVersionType: '',
              lastVersionNumber: '',
              serviceId: service.serviceId,
              isActive : service.isActive
            }
            return serviceDto;
          });
          this.AllMappingList = res.environmentsConfig;

          //Get All Active Environments from Master Legos
          this.environmentsList = res.environmentsConfig.map((env: any) => {
            const envDto = {
              key: env.id,
              value: env.environmentName
            }
            return envDto;
          });
          // load the initial environment list
          this.filteredEnvironmentsMulti.next(this.environmentsList.slice());
          // listen for search field value changes
          this.environmentsFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filterEnvironments();
            });
          res.versionTypesConfig = res.versionTypesConfig.filter((versn: any) => {
            return versn.name !== "Patch" && versn.name !== "Hotfix";
          });

          this.versionTypeList = res.versionTypesConfig.map((versn: any) => {
            const versionTypeDto = {
              key: versn.code,
              value: versn.name
            }
            return versionTypeDto;
          });

          

          this.releaseId = Number(this.route.snapshot.paramMap.get('releaseId')) || 0;
          if (this.releaseId && this.releaseId !== 0) {
            this.getExistingServiceRecord();
          } else {
            this.onDefaultVersionTypeChange();
          }


        }
        this.loader.showSpinner.next(false);
        this.cdr.detectChanges();
      }, error: (error) => {
        this.loader.showSpinner.next(true);
        this.toastr.error('Failed to load environments');
      }
    })


    this.releaseId = Number(this.route.snapshot.paramMap.get('releaseId')) || 0;
    if (this.releaseId === 0) {
      this.readonlyMode = !this.userAuthService.checkPermission('MANAGE.RELEASE.ADD');
      this.enableAuditTrail = false;
    } else {
      this.readonlyMode = (!this.userAuthService.checkPermission('MANAGE.RELEASE.MODIFY')
        && this.userAuthService.checkPermission('MANAGE.RELEASE.STATUS.VIEW'));
      this.enableAuditTrail = true;
    }
    if (this.readonlyMode) {
      setTimeout(() => this.form.disable());
    }
    

  }
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  filterEnvironments() {
    if (!this.environmentsList) {
      return;
    }
    // get the search keyword
    let search = this.environmentsFilterCtrl.value;
    if (!search) {
      this.filteredEnvironmentsMulti.next(this.environmentsList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the environments
    this.filteredEnvironmentsMulti.next(
      this.environmentsList.filter(env => env.value.toLowerCase().indexOf(search) > -1)
    );
  }
  CheckAllCheckboxStatus(){
    this.filteredEnvironmentsMulti.subscribe(list=>{
    const environments=this.form.get('environments')?.value.length > 0 ? this.form.get('environments')?.value : [];
    this.allElementsSelected = list.length > 0 && list.every(env => environments.some(e => e.value === env.value))
    this.CheckIntermittentStatus(list,environments)
  })
  }

  CheckIntermittentStatus(list, environments, ){
      this.anyElementsSelected = list.length > 0 && list.some(env => environments.some(e => e.value === env.value)) &&!this.allElementsSelected;
  }
  
  toggleSelectAll(selectAllValue: boolean) {
    this.filteredEnvironmentsMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        if (selectAllValue) {
          this.form.get('environments')?.patchValue(this.environmentsList.map(env => env));
        } else {
          this.form.get('environments')?.patchValue([]);
        }
        this.allElementsSelected = selectAllValue;
        this.onEnvironmentChange();
      });
  }
  /* istanbul ignore next */
  onEnvironmentChange() {
    this.CheckAllCheckboxStatus();
    

    const EnvString: string[] = this.form.get('environments').value.map((env: any) => env.value);
    if (EnvString.length === 0) {
      this.releaseServicesList = this.AllServiceList;
      
      this.releaseServicesList = [];
      return;
    }
    this.loader.showSpinner.next(true);

    this.releaseMgmtService.apiGetServiceListByEnv(EnvString).subscribe({
      next: (res) => {
        if (res) {
          this.InfoForService = res.services;
          // Clear the existing list
          this.releaseServicesList = [];

          // Iterate over each environment in res.environments
          Object.entries(res.environments).forEach(([envName, serviceNames]: [string, string[]]) => {
            // For each service name in the environment
            serviceNames.forEach((serviceName: string) => {
              // Find the matching service config from res.servicesConfig
              const serviceConfig = this.AllServiceList.find((svc: any) => svc.serviceName === serviceName);
              if (serviceConfig) {
                // Check if this service/environment combination already exists in the list
                const alreadyExists = this.releaseServicesList.some(
                  (svc: any) => svc.serviceName === serviceName
                  //&& svc.selectedEnvironment === envName
                );
                // If alreadyExists, add envName to selectedEnvironment as an array
                if (alreadyExists) {
                  const existingService = this.releaseServicesList.find(
                    (svc: any) => svc.serviceName === serviceName
                  );
                  if (existingService) {
                    if (!Array.isArray(existingService.selectedEnvironment)) {
                      existingService.selectedEnvironment = [existingService.selectedEnvironment];
                    }
                    if (!existingService.selectedEnvironment.includes(envName)) {
                      existingService.selectedEnvironment.push(envName);
                    }
                    existingService.mappedServiceNames = '';

                  }
                }
                else {
                  this.releaseServicesList.push({
                    isActive : serviceConfig.isActive || false,
                    isSelected: serviceConfig.isSelected || false,
                    serviceName: serviceConfig.serviceName,
                    versionType: serviceConfig.versionType || '',
                    isAlreadyExist: serviceConfig.isAlreadyExist || false,
                    versionNumber: serviceConfig.versionNumber || '',
                    previousNumber: '',
                    lastVersionType: '',
                    lastVersionNumber: '',
                    serviceId: serviceConfig.serviceId,
                    selectedEnvironment: envName,
                    mappedServiceNames: ''
                  });
                }
              }
            });
          });

        }

        this.releaseServicesList = this.releaseServicesList.filter(svc => svc.isSelected === true || svc.isActive === true);

        this.onMapServiceChange();
        this.onDefaultVersionTypeChange();
        this.loader.showSpinner.next(false);      
        this.cdr.detectChanges();

      },
      error: (error) => {
        this.loader.showSpinner.next(false);      
        this.toastr.error('Failed to load environments');
      }
    });
  }
  onMapServiceChange() {
    const EnvString: string[] = this.form.get('environments').value.map((env: any) => env.value);
    if (EnvString.length > 0) {

      this.releaseServicesList.forEach((service: any) => {
        let mappedEnvs: string[] = [];
        EnvString.forEach((envName: string) => {
          const mapping = this.AllMappingList.find((x: any) => x.environmentName === envName);
          if (mapping && Array.isArray(mapping.services)) {
            const found = mapping.services.find((svc: any) => svc.serviceName === service.serviceName);
            if (found && !mappedEnvs.includes(envName)) {
              mappedEnvs.push(envName);
            }
          }
        });
        service.mappedServiceNames = mappedEnvs.join(', ');
      });
    }

  }
  checkAllSelected(releaseServicesList: any[]) {
    if (releaseServicesList.length > 0) {
      this.allselected = releaseServicesList.every((service: any) => service.isSelected);
      this.isIndeterminate = releaseServicesList.some((service: any) => service.isSelected) && !this.allSelected;
    } else {
      this.allselected = false;
      this.isIndeterminate = false;
    }
  }
  captureOriginalVersion(row: any): void {
    if (row.existingVersion) {
      row.previousVersionNumber = row.existingVersion;
    }
    if(row.existingVersionType){
      row.previousVersionType = row.existingVersionType;
    }
  }

  onVersionValidate(value: string, versionType: any, row: any): void {
    if (row.existingVersion && row.existingVersionType) {
      // Allow if value is exactly the same as previousVersionNumber
      if ((value || '') === (row.previousVersionNumber || '')) {
        row.versionNumber = value;
        return;
      }
      const inputVersionType = versionType.value;
      const lastVersionType = row.previousVersionType;

    const inputSegments = (value || '').split('.');
      const lastSegments = (row.previousVersionNumber || '').split('.');

      if (inputSegments.length !== lastSegments.length) {
        this.toastr.error('Version format must be like: 3.2.1.0', 'Incorrect Format');
        row.versionNumber = row.previousVersionNumber;
        return;
      }

      const type = inputVersionType.toLowerCase();
      const typeToIndexMap: any = {
        major: 0,
        minor: 1,
        patch: 2,
        build: 3,
      };

    const allowedIndex = typeToIndexMap[type];
      let hasChangedOnlyAllowed = true;
      let isIncrement = true;

      let isChanged = false;
      for (let i = 0; i < inputSegments.length; i++) {
        const input = parseInt(inputSegments[i], 10);
        const last = parseInt(lastSegments[i], 10);

        if (isNaN(input) || isNaN(last)) {
      this.toastr.error('Version contains non-numeric parts.', 'Invalid Format');
          row.versionNumber = row.previousVersionNumber;
      return;
    }

        if (i < allowedIndex) {
          // Higher segments must not change
          if (input !== last) {
            hasChangedOnlyAllowed = false;
          }
        } else if (i === allowedIndex) {
          if (input < last) {
            isIncrement = false; // Must be strictly greater
          }
          if (input > last) {
            isIncrement = true; // Must be strictly greater
          }
          if (input !== last) {
            isChanged = true;
          }
        } else {
          // Lower segments can remain the same as previous (not necessarily zero)
          if (input !== last) {
            hasChangedOnlyAllowed = false;
          }
        }
      }

      // If no change at all, allow it (no error)
      if (!isChanged && hasChangedOnlyAllowed) {
         row.versionNumber = value;
        return;
      }

      if (!hasChangedOnlyAllowed) {
        this.toastr.error(`Only the ${type} version is allowed to be modified and other segments must be same as previous.`, 'Segment Issue');
        row.versionNumber = row.previousVersionNumber;
        row.lastVersionType = inputVersionType;

        return;
      }

      if (!isIncrement && isChanged) {
        this.toastr.error(`The ${type} version must be incremented (greater than previous).`, 'Version Decrement');
        row.versionNumber = row.previousVersionNumber;
        row.lastVersionType = inputVersionType;

        return;
      }

      row.versionNumber = value;
    }
  }
  /* istanbul ignore next */
  initMatComponent() {
    [].map.call(document.querySelectorAll('.text-material'), function (element) {
      textField.MDCTextField.attachTo(element);
    });

    [].map.call(document.querySelectorAll('.ripple-material'), function (el) {
      ripple.MDCRipple.attachTo(el);
    });
  }

  /* istanbul ignore next */
  ngAfterViewInit() {
    this.releaseId = Number(this.route.snapshot.paramMap.get('releaseId')) || 0;
    if (this.IsNullOrEmpty(this.releaseId) || this.releaseId === 0) {
      this.initMatComponent();
    }
    setTimeout(() => {
      [].map.call(document.querySelectorAll('.text-material'), function (element) { textField.MDCTextField.attachTo(element); });
      [].map.call(document.querySelectorAll('.ripple-material'), function (el) { ripple.MDCRipple.attachTo(el); });
      [].map.call(document.querySelectorAll('.formfield-material'), function (elem) { formField.MDCFormField.attachTo(elem); });
    }, 2000);

  }
  /* istanbul ignore next */
  onVersionChange(row) {
    if (row.versionType) {
      // Show the spinner by setting the value of "showSpinner" property in "loader" object to true
      
      // Call the "apiGetVersionNumberByVersionType" method of "releaseMgmtService" object, passing the "versionType" value and "serviceName" from "row" as arguments
      // Subscribe to the response of the API call
      this.loader.showSpinner.next(true);      

      this.releaseMgmtService.apiGetVersionNumberByVersionType(this.releaseId, row.versionType.value, row.serviceName).subscribe({
        next: (res) => {
          // If the response is not null or undefined
          if (res) { row.versionNumber = res; 
            row.existingVersionType = row.versionType.value;
            row.existingVersion = res;
             }
                     this.loader.showSpinner.next(false);      

        }, error: (error) => {
          // If there is an error in the API call, log the error to the console
          // Hide the spinner by setting the value of "showSpinner" property in "loader" object to false
                  this.loader.showSpinner.next(false);      
          
        }
      })
    }
  }

  checkIfNotSelected(row): boolean {
    return !row.isSelected || row.isAlreadyExist;
  }

  getExistingServiceRecord(): any {
              

    this.releaseId = Number(this.route.snapshot.paramMap.get('releaseId')) || 0;
    if (this.releaseId && this.releaseId !== 0) {
      this.releaseMgmtService.apiGetReleaseDataById(this.releaseId).subscribe({
        next: (res) => {
          if (res) {

            this.hideField = res.repoCreationStatus;
            this.form.controls["releasePrefix"].setValue(res.releasePrefix);
            this.form.controls["releaseName"].setValue(res.releaseName);
            this.form.controls["environments"].patchValue(res.environmentsConfigMapping.map((env: any) => {
              const selected = this.environmentsList.find(x => x.value === env.environmentName);
              return selected;
            }));
            this.onEnvironmentChange();
            this.AllServiceList.forEach((service: any) => {
              const serviceDto = res.servicesConfigMapping.find(x => x.serviceId == service.serviceId);
              if (serviceDto) {
                service.versionType = { key: this.versionTypeList.find(x => x.value == serviceDto.versionType).key, value: serviceDto.versionType };
                service.versionNumber = serviceDto.versionNumber;
                service.isAlreadyExist = true;
                service.isSelected = true;
              }
            });
            const topResult = res.servicesConfigMapping
              ?.sort((a, b) => (a.versionType < b.versionType ? 1 : -1))[0];

            if (topResult?.versionType) {
              this.form.controls["selectedVersionType"].setValue(topResult.versionType);
            } else {
              this.form.controls["selectedVersionType"].reset(); // or set a default value if needed
            }
            this.initMatComponent();
          }
        }, error: (error) => {
          this.toastr.error('Failed to load release data');}
      })
    }
                      

    this.onDefaultVersionTypeChange();

  }

  onDefaultVersionTypeChange() {
    this.selectedVersionType = this.form.get('selectedVersionType').value;

    if (this.selectedVersionType) {
      
      this.releaseMgmtService.apiGetDefaultVersionNumberByVersionType(this.releaseId, this.selectedVersionType).subscribe({
        next: (res) => {
          if (res) {
            this.releaseServicesList.forEach((row: any) => {
              if (row.isAlreadyExist) {
                // Skip services that already have data
                return;
              }
              const matchedVersion = res[row.serviceName];
              if (matchedVersion) {
                row.versionNumber = matchedVersion;
                row.existingVersion = matchedVersion;
                row.existingVersionType = this.selectedVersionType;
                row.versionType = {
                  key: this.versionTypeList.find(x => x.value === this.selectedVersionType).key,
                  value: this.selectedVersionType
                };
              }
            });

            
            this.checkAllSelected(this.releaseServicesList);
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          console.error('Failed to fetch default version number:', error);
          
        }
      });
    }
  }

  isInvalidForm() {
    if (this.form.invalid || !this.releaseServicesList.some(x => x.isSelected === true) ||
      this.releaseServicesList.some(x => x.isSelected === true && (this.IsNullOrEmpty(x.versionNumber) || this.IsNullOrEmpty(x.versionType)))) {
      return true;
    }
    return false;
  }

  // omit special characters
  omit_special_char(event, isAlphaNumeric: boolean, addtionalCharAllowed: number[] = []) {
    let k;
    // get char code
    k = event.charCode;

    if (isAlphaNumeric) {
      // allowed only Alphabets, numbers, full stop & hyphen
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k) || k == 45 || k == 46 || (k >= 48 && k <= 57));
    }
    else {
      // allowed only number & full stop
      return (k == 46 || (k >= 48 && k <= 57));
    }
  }

  // omit special characters on paste
  on_paste_omit_special_char(event: ClipboardEvent, control, addtionalCharAllowed: number[] = []) {
    // local variables
    let clipboardData = event.clipboardData;
    let filteredText = '';

    // get text
    let pastedText = clipboardData.getData('text');
    let k;

    // loop to check for every char
    for (let i = 0; i < pastedText.length; i++) {
      k = pastedText.charCodeAt(i);
      if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || addtionalCharAllowed.includes(k) || k == 45 || k == 46 || (k >= 48 && k <= 57)) {
        filteredText += pastedText.charAt(i)
      }
    }
     window.document.execCommand('insertText', false, filteredText);

    // return false
    return false;
  }
  async openDeploymentDialog() {
    this.envServiceMap = {};
    this.releaseServicesList
      .filter(service => service.isSelected)
      .forEach(service => {
        if (service.selectedEnvironment && Array.isArray(service.selectedEnvironment)) {
          service.selectedEnvironment.forEach((env: string) => {
            if (!this.envServiceMap[env]) {
              this.envServiceMap[env] = service.serviceName;
            } else {
              this.envServiceMap[env] += ', ' + service.serviceName;
            }
          });
        } else if (service.selectedEnvironment) {
          // Handle single environment string
          const env = service.selectedEnvironment;
          if (!this.envServiceMap[env]) {
            this.envServiceMap[env] = service.serviceName;
          } else {
            this.envServiceMap[env] += ', ' + service.serviceName;
          }
        }
      });
    const confirmed = await this.confirmationDialog.showReleaseConfirmation(this.envServiceMap, 'release', this.InfoForService);

    if (confirmed) {
      this.proceedForSave();
    }
  }

  save() {
    this.openDeploymentDialog();
  }

  proceedForSave() {
    let releaseName = this.form.get('releaseName').value;
    let releasePrefix = this.form.get('releasePrefix').value;

    if (this.isInvalidForm() || (releaseName && releaseName.trim() == '') || (releasePrefix && releasePrefix.trim() == '')) {
      this.toastr.error('Please fill the all details properly', 'Error');
      return;
    }
    const serviceMappingDetails: ReleaseConfigurationMappingDto = {
      Id: this.releaseId,
      ReleaseName: this.form.get('releaseName').value,
      ReleasePrefix: this.form.get('releasePrefix').value,
      ServicesConfigMapping: this.releaseServicesList.filter(x => x.isSelected === true).map((service: any) => {
        return {
          Id: 0, ServiceName: service.serviceName, VersionType: service.versionType.value, VersionNumber: service.versionNumber, ReleaseId: this.releaseId
          , ParentReleaseId: null, BranchName: null, serviceId: service.serviceId, isActive: service.isActive || false
        }
      }),
      EnvironmentsConfigMapping: this.form.get('environments').value.map((env: any) => { return { EnvironmentId: env.key, EnvironmentName: env.value, ReleaseId: this.releaseId } })

    };
    
    this.releaseMgmtService.apiSaveReleaseDetails(serviceMappingDetails).subscribe({
      next: (res) => {
        if (res) { this.toastr.success('The Release definition is saved successfully', 'Success');  this.router.navigate(["release"]); }
      }, error: (error) => { console.log(error);  }
    })
  }

  cancel() {
    this.router.navigate(["release"]);
  }

  IsNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }
  toggleAllRows() {
    this.releaseServicesList.forEach(service => {
      if (!service.isAlreadyExist) {
        service.isSelected = this.allSelected;
      }
    });
    this.isIndeterminate = false;

  }
  onRowCheckboxChange() {
    const total = this.releaseServicesList.length;
    const selected = this.releaseServicesList.filter(service => service.isSelected).length;
    this.allSelected = selected === total;
    this.isIndeterminate = selected > 0 && selected < total;

  }
  isEnvironmentMissing(): boolean {
    const environment = this.form.get('environments')?.value || [];
    if (environment.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  isVersionTypeMajor(): boolean {
    const versionType = this.form.get('selectedVersionType')?.value;
    return versionType.toLowerCase() === 'major';
  }

  navigateToAuditTrail() {
  this.router.navigate(
  ['/release/define-releases/audit-trails', this.releaseId],
  { queryParams: { backTo: 'release' } }
);
}
}
